export const specialSteps = {
    ApplicationSubmitted: 'ApplicationSubmitted',
    ApplicationUpdated: 'ApplicationUpdated',
    FinishLater: 'FinishLater',
    ApplicationWithdrawn: 'ApplicationWithdrawn',
    SubmissionRequirement: 'SubmissionRequirement',
}